import { useTranslation } from 'next-i18next';

import { splitRemaining } from '@/shared/plan/trialEndDiscount';

const pad = (value: number) => String(value).padStart(2, '0');

/**
 * "6일 23시간 59분" / "종료까지 6일 23시간 59분" (Figma 29139:2449, 29139:3337).
 * 분 단위라 초는 만들지 않는다.
 */
export function useTrialEndCountdownText(remainingMs: number) {
  const { t } = useTranslation(['common']);
  const { days, hours, minutes } = splitRemaining(remainingMs);
  const values = { days, hours: pad(hours), minutes: pad(minutes) };

  return {
    countdown: t('common:trialEndDiscount.countdown', values),
    withPrefix: t('common:trialEndDiscount.countdownWithPrefix', values),
  };
}
